'use client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ErrorBoundary } from 'react-error-boundary';
import { GoogleOAuthErrorFallback } from '@/components/ErrorFallback';
import { GoogleOAuthContext } from '@/contexts/GoogleOAuthContext';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID!;

export default function GoogleOAuthProviderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const isGoogleOAuthAvailable = !!GOOGLE_CLIENT_ID;

  if (!isGoogleOAuthAvailable) {
    console.warn('Google Client ID not found. Google OAuth will not work.');
    return (
      <GoogleOAuthContext.Provider value={{ isGoogleOAuthAvailable }}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          {children}
        </GoogleOAuthProvider>
      </GoogleOAuthContext.Provider>
    );
  }

  return (
    <ErrorBoundary FallbackComponent={GoogleOAuthErrorFallback}>
      <GoogleOAuthContext.Provider value={{ isGoogleOAuthAvailable: true }}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          {children}
        </GoogleOAuthProvider>
      </GoogleOAuthContext.Provider>
    </ErrorBoundary>
  );
}
